import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import AudioPlayer from "react-h5-audio-player"

const Player = ({url, intervalEvent, name }) => {
  const [howFar, setHowFar] = useState(0)
  
  return (
    <>
          <AudioPlayer
        autoPlay={false}
        src={url}
        onPlay={e => console.log("onPlay")}
        listenInterval={1000}
        onListen={intervalEvent}
        // other props here
      />
      </>
  )
}

export default Player
